module.exports = __webpack_public_path__ + "img/default_doctor.aa1b0cde.png";